// Whether the orange "restricted" line under a transition button should render. For an
// open_measurement block the resolution area already prints the same live reason, so showing both
// duplicated the message (QA #4).
interface BlockedTransition {
  transition_code: string;
  executable?: boolean;
  reason?: string | null;
  resolution?: { action_type?: string } | null;
}

/** The text for the restricted line: the transition's CURRENT reason, falling back to the one captured
 *  at click time. The captured copy alone went stale as soon as the user fixed what was missing. */
export function restrictedReasonText(
  tr: BlockedTransition,
  restricted: { code: string; reason: string },
): string {
  return tr.reason || restricted.reason;
}

export function shouldShowRestrictedReason(
  tr: BlockedTransition,
  restricted: { code: string; reason: string } | null,
): boolean {
  if (!restricted || restricted.code !== tr.transition_code) return false;
  // Nothing is restricted any more (the missing data was filled in): drop the stale line.
  if (tr.executable) return false;
  const shownInline = tr.resolution?.action_type === 'open_measurement' && restrictedReasonText(tr, restricted) === tr.reason;
  return !shownInline;
}
